module.exports = __webpack_public_path__ + "img/1F971.1efd3da9.svg";